module.exports = __webpack_public_path__ + "img/p2-p4-ditu.f53539dd.png";